export default __webpack_public_path__ + "static/media/car01.2648b0e3.jpg";